const styles = () => ({
  sendAgainContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "16px 0px",
    minHeight: "55px",
  },
  sendAgainButtonText: {
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: "#889db3",
    textTransform: "capitalize",
  },
  sendAgainButton: {
    borderRadius: "40px",
    border: "none",
    backgroundColor: "#18AA33",
    color: "#ffffff",
    padding: "10px 20px",
    boxShadow: "none",
    transition: "all 300ms",
    "&:hover": {
      backgroundColor: "#0F6B20",
    },
  },
  sendAgainButtonDisabled: {
    border: "1px solid #f0f2f4 !important",
    padding: "6px 12px",
  },
  sendAgainButtonIcon: {
    fontSize: "16px !important",
    backgroundColor: "#ebedf1",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  openCareemAppButton: {
    fontWeight: 600,
    lineHeight: "24px",
    fontSize: "16px",
    textTransform: "capitalize",
  },
  appStoreImg: {
    objectFit: "cover",
  },
  title: {
    margin: "1.5rem 0rem",
  },
  formTitle: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#2D2E2E",
    "@media only screen and (max-width: 480px)": {
      fontSize: "20px",
    },
  },
  formSubtitle: {
    fontSize: "16px",
    color: "#5D758F",
    margin: "4px 0px",
    "& > span": {
      fontWeight: 700,
      fontSize: "16px",
    },
  },
  textButton: {
    outline: "none",
    background: "none",
    border: "none",
    padding: 0,
    color: "#18AA33",
    fontSize: "16px",
    fontWeight: 600,
  },
  notificationBox: {
    position: "absolute",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gridColumnGap: "4px",
    top: 0,
    left: "50%",
    transform: "translateX(-50%)",
  },
  notificationText: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#889DB4",
  },
  tickIcon: {
    color: "#889DB4",
    marginTop: "3px",
  },
  grey500: {
    color: "#5D758F",
  },
  textSuccess: {
    color: "#18AA33",
  },
  textSmall: {
    fontSize: "14px",
  },
});

export default styles;
